$(function () {
  if (!customElements.get("content-over-media")) {
    customElements.define(
      "content-over-media",
      class extends HTMLElement {
        // 当前选中索引
        dialogCurrentProduct = 0;
        // swiper实例
        swiperInstance = [];
        product = {};
        options = [];
        currentProduct = {};
        constructor() {
          super();
          this.initBoxClick();
          this.watchWindowClick();
          this.mobileDlalogClose();
          this.initSwiper();
          // this.initDialogTab();
          this.initDialogSwiper();
          this.initSelects();
          // this.checkActive();
          // this.addToCart();
          this.swiperDialogShow();
        }
        detectDevice() {
          var userAgent = navigator.userAgent.toLowerCase();
          var isMobile =
            /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
              userAgent
            );
          return isMobile;
        }
        initDialogTab() {
          const that = this;
          $(this)
            .find(".dialog_image")
            .click(function () {
              $(that).find(".dialog_image").removeClass("active");

              const index = $(this).index();
              // 当前产品索引
              that.dialogCurrentProduct = index;
              $(this).parent().next().find(".swiper").removeClass("show");
              $(this)
                .parent()
                .next()
                .find(".swiper")
                .eq(index)
                .addClass("show");
              $(this).parent().next().find("h1").removeClass("show");
              $(this).parent().next().find("h1").eq(index).addClass("show");

              $(this)
                .parent()
                .siblings(".inventory-container")
                .find(".inventory")
                .removeClass("show");
              $(this)
                .parent()
                .siblings(".inventory-container")
                .find(".inventory")
                .eq(index)
                .addClass("show");
              $(this).addClass("active");
              that.checkActive();
            });
        }
        watchWindowClick() {
          $(this)
            .find(".dialog_pc")
            .click(function (e) {
              e.stopPropagation();
            });
          window.addEventListener("click", function (event) {
            const modal = $(this).find(".dialog_pc").is(":hidden");
            if (!modal) {
              $(this).find(".dialog_pc").hide();
              $(this).find(".box").removeClass("rotate");
            }
          });
        }
        closeMobile() {
          $(this).find(".modal").removeClass("animate__fadeInUp");
          $(this).find(".modal").addClass("animate__fadeOutDown");
          $("body").css({
            overflow: "auto",
          });
          $(this).find(".box").removeClass("rotate");
          setTimeout(() => {
            $(this).find(".dialog_mobile").hide();
          }, 500);
        }
        mobileDlalogClose() {
          const that = this;
          $(this)
            .find(".dialog_mobile")
            .click(function () {
              that.closeMobile();
            });
          $(".cancelbutton").click(function (e) {
            e.stopPropagation();
            that.closeMobile();
          });
          $(this)
            .find(".dialog_mobile .content")
            .click(function (e) {
              e.stopPropagation();
            });
        }
        initBoxClick() {
          const that = this;
          $(this)
            .find(".content-box")
            .click(function (event) {
             const index = $(this).find(".box").attr("data-index");
              event.stopPropagation();
              if (that.detectDevice() && innerWidth <= 750) {
                $(that).find(".modal").addClass("animate__fadeInUp");
                $(that).find(".modal").removeClass("animate__fadeOutDown");
                $(that).find(".dialog_mobile").css({ display: "flex" });
                 that.swiperInstance[0].slideTo(index)
                $(that).find(".cancelbutton").show();
              } else {
               
                that.swiper.slideTo(index);
              }
            });
        }
        initSwiper() {
          const swiperEl = $(this).find(
            ".content-over-media--swiper-box .swiper"
          )[0];
          const that = this;
          this.swiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            autoHeight: true,
          });
          $(this)
            .find(".my-swiper-button-prev-over-media")
            .click(function () {
              that.swiper.slidePrev();
            });
          $(this)
            .find(".my-swiper-button-next-over-media")
            .click(function () {
              that.swiper.slideNext();
            });
        }
        initDialogSwiper() {
          const that = this;
          const swiperEl = $(this)
            .find(".dialog_product .swiper")
            .each((idx, el) => {
              that.swiperInstance[idx] = new Swiper(el, {
                slidesPerView: 1,
                autoHeight:true
              });
            });
        }
        initSelects() {
          const that = this;
          $(this)
            .find(".product_options .product_option")
            .click(function () {
              $(this).siblings().removeClass("active");
              $(this).addClass("active");

              $(this).parent().prev().find("b").text($(this).text());
              that.checkActive();
              that.switchSwiper();
            });
        }
        checkActive() {
          const that = this;
          $(this)
            .find(".inventory-container .inventory")
            .eq(this.dialogCurrentProduct)
            .find(".product_select .active")
            .each(function (index, el) {
              const gropu = $(el).attr("data-group");
              that.options[gropu] = $(el).attr("data-val");
            });
          const handle = $(this)
            .find(".inventory-container .inventory")
            .eq(this.dialogCurrentProduct)
            .attr("data-handle");

          if (this.product[handle]) {
            that.checkSelect(handle);
            
          } else {
            this.getProduct(handle).then((res) => {
              that.checkSelect(handle);
            });
          }
        }
        getProduct(handle) {
          const that = this;
          return new Promise((resolve, reject) => {
            fetch(window.Shopify.routes.root + `products/${handle}.js`)
              .then((response) => response.json())
              .then((product) => {
                that.product[handle] = product;
                resolve();
              });
          });
        }
        checkSelect(handle) {
          const variants = this.product[handle].variants;
          const that = this;
          this.getCurrentProduct(handle);
          // 遍历每一个单选框获取是否可选状态
          $(this)
            .find(".inventory-container .inventory")
            .eq(this.dialogCurrentProduct)
            .find(".product_select .product_option")
            .each(function (index, el) {
              const groupIndex = $(el).attr("data-group");
              // 忽略第一组
              if (groupIndex != 0) {
                const currentValue = $(el).attr("data-val");
                const currentSelectd = [...that.options];
                currentSelectd[groupIndex] = currentValue;
                const found = variants.find((i) => {
                  let hasProduct = true;
                  for (let index = 0; index < currentSelectd.length; index++) {
                    if (i.options[index] != currentSelectd[index]) {
                      hasProduct = false;
                    }
                  }
                  return hasProduct;
                });

                if (found && found.available) {
                  //可用
                  $(el).removeClass("unavailable");
                  $(el).removeClass("sell-out");
                } else if (found && !found.available) {
                  // 售罄
                  $(el).removeClass("unavailable");
                  $(el).addClass("sell-out");
                } else if (!found) {
                  // 不可用
                  $(el).addClass("unavailable");
                  $(el).removeClass("sell-out");
                }
              }
            });
        }
        replaceMoneyFormat(price){
          return $(this)
              .attr("price-format")
              .replace(/{{\s*([a-zA-Z0-9_]+)\s*}}/g, price)
        }
        getCurrentProduct(handle) {
          const variants = this.product[handle].variants;
          const that = this;
          // 查找当前选中商品
          that.currentProduct = variants.find((i) => {
            return that.options.every((item, index) => {
              return item == i.options[index];
            });
          });
          // 如果该规格存在且可购买
          if (that.currentProduct && that.currentProduct.available) {
            const price = (that.currentProduct.price / 100).toFixed(2);
            const compare = (
              that.currentProduct.compare_at_price / 100
            ).toFixed(2);
            const money = this.replaceMoneyFormat(price);
            const compareMoney = this.replaceMoneyFormat(compare);
            const diff = (compare-price).toFixed(2);
            const scale = (diff/compare*100).toFixed(0);
            $(this)
              .find(".dialog_swiper h1")
              .eq(this.dialogCurrentProduct)
              .find(".price-item--sale")
              .text(money);
            $(this)
              .find(".dialog_swiper h1")
              .eq(this.dialogCurrentProduct)
              .find(".price-item--regular")
              .text(compareMoney);
            const priceBadege = `${scale} OFF - Save ${this.replaceMoneyFormat(diff)}`
            $(this)
              .find(".dialog_swiper h1")
              .eq(this.dialogCurrentProduct)
              .find(".badge")
              .text(priceBadege);
            $(this)
              .find(".inventory-container .inventory")
              .eq(this.dialogCurrentProduct)
              .find(".content-over-media-desc")
              .text(that.currentProduct.description);
            $(this).find(".product-submit-btn").removeClass("unavailable");

            $(this).find(".product-submit-btn .unavailable").hide();
            $(this).find(".product-submit-btn .sold_out").hide();
            $(this).find(".product-submit-btn .add_to_card_btn").show();
            $(this).find(".product-submit-btn .content-over-money").text(money);
          } else if (that.currentProduct && !that.currentProduct.available) {
            // 该规格存在但是售罄
            $(this).find(".product-submit-btn .sold_out").show();
            $(this).find(".product-submit-btn .add_to_card_btn").hide();
            $(this).find(".product-submit-btn .unavailable").hide();
          } else {
            // 该规格不存在
            $(this).find(".product-submit-btn").addClass("unavailable");
            $(this).find(".product-submit-btn .add_to_card_btn").hide();
            $(this).find(".product-submit-btn .sold_out").hide();
            $(this).find(".product-submit-btn .unavailable").show();
          }
        }
        addToCart() {
          const that = this;
          $(this)
            .find(".product-submit-btn")
            .click(function (e) {
              e.stopPropagation();
              $.getJSON(
                `${routes.cart_add_url}`,
                {
                  quantity: 1,
                  id: that.currentProduct.id,
                  sections:
                    "cart-notification-product,cart-notification-button,cart-icon-bubble",
                },
                function (res) {
                  let cartDom =
                    document.querySelector("cart-notification") ||
                    document.querySelector("cart-drawer");
                  if (!cartDom) {
                    window.location = window.routes.cart_url;
                    return;
                  }
                  that.closeMobile();
                  $(".product_float_pop_mask").slideToggle();
                  cartDom.renderContents(res);
                  $(this).attr("aria-disabled", false);
                }
              );
            });
        }
        //切换swiper
        switchSwiper() {
          const product= this.currentProduct
          if (product.featured_image && product.featured_image.position) {
            const index = product.featured_image.position;
            this.swiperInstance[this.dialogCurrentProduct].slideTo(index - 1);
          }
        }
        swiperDialogShow() {
          const that = this
          $(this).find(".dialog_show_image").click(function(){
            $(this).hide()
          })
          $(this).find(".dialog_swiper .swiper img").click(function () {
            $(that).find(".dialog_show_image").hide()
            $(that).find(".dialog_show_image img").attr("src",$(this).attr("src"))
            $(that).find(".dialog_show_image").show()
          })
        }
      }
    );
  }
});
